/**
 * JargonContext — Super Admin Basic/Advanced jargon toggle (2026-09-01 directive).
 *
 * Global, per-account preference (saved via /admin/prefs/jargon-level) that
 * drives every <Jargon term="..."/> across the Admin dashboard's 25 tabs.
 * Defaults to "basic" (plain English) — "advanced" restores the original
 * technical labels with no decoration.
 */
import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const JargonCtx = createContext(null);
export const useJargon = () => useContext(JargonCtx) || { level: "basic", setLevel: () => {} };

export function JargonProvider({ children }) {
    const { user } = useAuth();
    const [level, setLevelState] = useState("basic");

    useEffect(() => {
        if (user?.admin_jargon_level === "advanced" || user?.admin_jargon_level === "basic") {
            setLevelState(user.admin_jargon_level);
        }
    }, [user?.admin_jargon_level]);

    const setLevel = useCallback(async (next) => {
        setLevelState(next);
        try { await api.post("/admin/prefs/jargon-level", { level: next }); } catch { /* non-critical — already switched locally */ }
    }, []);

    const value = useMemo(() => ({ level, setLevel }), [level, setLevel]);

    return <JargonCtx.Provider value={value}>{children}</JargonCtx.Provider>;
}
